var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CvTextarea",class:_vm.elmClasses},[_c('BaseTextarea',{attrs:{"value":_vm.value},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }